import { createSlice } from '@reduxjs/toolkit';
import { UiState } from 'constants/ui';
import { ExtraServiceCheckoutModal } from 'constants/extra-service';
import { stateName } from './constants';
export const initialState = {
  selectedIds: [],
  vasGalleryBanner: {
    uiState: UiState.Idle,
    items: []
  },
  vasGalleryOrder: {
    uiState: UiState.Idle
  },
  vasGalleryCheckout: {
    activeModal: ExtraServiceCheckoutModal.None
  },
  vasGalleryPricing: {
    uiState: UiState.Idle
  }
};

const fetchVasGalleryRequest = draft => {
  draft.vasGalleryBanner.uiState = UiState.Pending;
};

const fetchVasGallerySuccess = (draft, action) => {
  draft.vasGalleryBanner = {
    items: action.payload.items,
    uiState: UiState.Success
  };
};

const fetchVasGalleryFailure = draft => {
  draft.vasGalleryBanner.uiState = UiState.Failure;
};

const fetchVasGalleryPricingRequest = draft => {
  draft.vasGalleryPricing.uiState = UiState.Pending;
};

const fetchVasGalleryPricingSuccess = (draft, action) => {
  const {
    vasGalleryPricing
  } = action.payload;
  draft.vasGalleryPricing = {
    pricing: vasGalleryPricing,
    uiState: UiState.Success
  };
};

const fetchVasGalleryPricingFailure = draft => {
  draft.vasGalleryPricing = {
    pricing: undefined,
    uiState: UiState.Failure
  };
};

const postVasGalleryOrderRequest = draft => {
  draft.vasGalleryOrder = {
    order: undefined,
    uiState: UiState.Pending
  };
};

const postVasGalleryOrderFailure = draft => {
  draft.vasGalleryOrder = {
    order: undefined,
    uiState: UiState.Failure
  };
};

const postVasGalleryOrderSuccess = (draft, action) => {
  const {
    vasGalleryOrder
  } = action.payload;
  draft.vasGalleryOrder = {
    order: vasGalleryOrder,
    uiState: UiState.Success
  };
};

const getVasGalleryOrderRequest = draft => {
  draft.vasGalleryOrder = {
    order: undefined,
    uiState: UiState.Pending
  };
};

const getVasGalleryOrderFailure = draft => {
  draft.vasGalleryOrder = {
    order: undefined,
    uiState: UiState.Failure
  };
};

const getVasGalleryOrderSuccess = (draft, action) => {
  const {
    vasGalleryOrder
  } = action.payload;
  draft.vasGalleryOrder = {
    order: vasGalleryOrder,
    uiState: UiState.Success
  };
};

const setSelectedItems = (draft, action) => {
  const {
    itemIds
  } = action.payload;
  draft.selectedIds = itemIds;
};

const setCheckoutModal = (draft, action) => {
  const {
    modal
  } = action.payload;
  draft.vasGalleryCheckout.activeModal = modal;
};

const startCheckout = (draft, action) => {
  const {
    selectedItemId
  } = action.payload || {};
  draft.vasGalleryCheckout.activeModal = ExtraServiceCheckoutModal.Checkout;

  if (selectedItemId) {
    draft.selectedIds = [selectedItemId];
  }
};

const cancelCheckout = draft => {
  draft.vasGalleryOrder = {
    uiState: UiState.Idle,
    order: undefined
  };
};

const vasGallerySlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    fetchVasGalleryRequest,
    fetchVasGallerySuccess,
    fetchVasGalleryFailure,
    postVasGalleryOrderRequest,
    postVasGalleryOrderSuccess,
    postVasGalleryOrderFailure,
    getVasGalleryOrderRequest,
    getVasGalleryOrderFailure,
    getVasGalleryOrderSuccess,
    fetchVasGalleryPricingRequest,
    fetchVasGalleryPricingSuccess,
    fetchVasGalleryPricingFailure,
    setSelectedItems,
    setCheckoutModal,
    startCheckout,
    cancelCheckout
  }
});
export const {
  actions
} = vasGallerySlice;
export const plug = {
  [stateName]: vasGallerySlice.reducer
};
export default vasGallerySlice.reducer;